<template>
    <div v-wechat-title="title" class="padding10" :style="{ 'min-height': `${this.screenHeight - 80}px` }">
        <DocFrame
            ref="doc"
            :style="{ 'overflow-y': `auto`, height: `${this.screenHeight - 80}px` }"
            :docbizid.sync="docbizid"
            :docno="this.$root.DOCUMENT && this.$root.DOCUMENT[this.docCode]"
            :surgeryId="surgeryId"
            @saved="afterDocSaved"
        ></DocFrame>
        <CloseButton ref="close-btn" type="confirm" @confirm="SaveChanges" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
    name: `Doc`,
    prop: {

    },
    data() {
        return {
            title: `麻醉单文书`,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            recordType: this.$route.query.record_type,
            docCode: this.$route.query.docCode,
            docbizid: this.$route.query.docbizid,
            multiQueryProduceConfig: this.$root.MultiQueryProduceConfig == `1`,
            guid: undefined,
            data: {},
            msg: `closeWindow`
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.getToken()
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        if (this.$root.DOCUMENT) {
            this.$nextTick(() => {
                this.$refs[`doc`] && this.$refs[`doc`].loadDocument()
            })
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`])
    },
    mounted() {
    },
    methods: {
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                console.log(`11111111111111111111111`, res)
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        afterDocSaved() {
            this.sendDocMessage().then(data => {
                this.$refs[`close-btn`].close()
            })
        },
        SaveChanges() {
            this.$refs.doc.save()
        },
        // 获取文书系统保存的明细项
        sendDocMessage() {
            return new Promise((resolve, reject) => {
                let info = { producename: `Sys_GetAnesthsiaDoc ${this.docbizid}` }
                if (this.multiQueryProduceConfig) {
                    info.validate = false
                }
                let req1 = this.myaxios.post_doc(`Query/MultiQueryProduce`, info)
                req1.then(data => {
                    let r = typeof winformMsg
                    if (r != `undefined`) {
                        var cefJson = {
                            data: data && data[0] && data[0].Column1 || ``,
                            docbizid: this.docbizid,
                            action: `doc_save`
                        }
                        winformMsg.acceptMessage(cefJson)
                    }
                    resolve()
                }).catch(e => reject(e))
            })
        }

    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
        }
    }
}
</script>
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/Doc.vue